import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    LOADING: false,
    HEADIMGURL:sessionStorage.getItem('token')||'',
    NICKNAME:sessionStorage.getItem('nickName')||'',
    TOKEN:sessionStorage.getItem('token')||'',
    USERID:sessionStorage.getItem('userid')||''
  },
  mutations: {
    showLoading(state){
      state.LOADING = true    
    },
    hideLoading (state) {
        state.LOADING = false
    },
    setHeadImgUrl(state,headImg){
      sessionStorage.setItem('headImg',headImg)
      state.HEADIMGURL = headImg
    },
    setNickName(state,nickName){
      sessionStorage.setItem('nickName',nickName)
      state.NICKNAME = nickName
    },
    setToken(state,token){
      sessionStorage.setItem('token',token)
      state.TOKEN = token
    },
    setUserId(state,userId){
      sessionStorage.setItem('userId',userId)
      state.USERID = userId
    }
  },
  actions: {

  },
  modules: {
    
  }
})
